var carousel = (function() {

  var carousel_items = $(".carousel .banner-item");

  setInterval(function() {
    var img = $(".carousel .banner-item.active, .carousel-navigation li.active");
    var next = $(img.next());

    next.addClass("active");
    img.removeClass("active");
    if (next.length === 0) {
      $(".carousel .banner-item").first().addClass("active");
      $(".carousel-navigation li").first().addClass("active");
    }

  }, 9000);

  console.log(carousel_items.length);

  carousel_items.each(function(i) {
    if(carousel_items.length > 1) {
      $(".carousel-navigation ul").append("<li data-target='" + i + "' " + (i == 0 ? "class='active'" : "") + "></li>");
    }
  });

  var navigation_items = $(".carousel-navigation li");

  navigation_items.on("click", function() {
    console.log("test");
    // Fade carousel in
    $(".banner-item").removeClass("active");
    $(".banner-item[data-carousel='" + $(this).data("target") + "']").addClass("active");
    // Change active navigation item
    navigation_items.removeClass("active");
    $(this).addClass("active");
  });


})();
